import { render, staticRenderFns } from "./manCard_zxq.vue?vue&type=template&id=ca68c44e&scoped=true&"
import script from "./manCard_zxq.vue?vue&type=script&lang=ts&"
export * from "./manCard_zxq.vue?vue&type=script&lang=ts&"
import style0 from "./manCard_zxq.vue?vue&type=style&index=0&id=ca68c44e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca68c44e",
  null
  
)

export default component.exports